import React from 'react';
import { GoogleMap, Marker, withGoogleMap } from 'react-google-maps';

const MapContainer = withGoogleMap(({ latitude, longitude }) => (latitude && longitude && <GoogleMap
  center={{ lat: latitude, lng: longitude }}
  defaultZoom={12}
><Marker position={{ lat: latitude, lng: longitude }}></Marker></GoogleMap>))

const VenueLocation = ({ eventLocation }) => {
  const { name, formattedAddress, details, latitude, longitude } = eventLocation;
  return (
    <div className="venueLocation">
      <div className="section-header col gotham-bold-font">Venue Location</div>
      <section>
        <div className="row">
          <div className="col nimbus-regular-font">
            <div className="location-name">{name}</div>
            <div className="location-address">{formattedAddress}</div>
            <div className="location-details">
              {details &&
                <span><i>Report to:</i> {details}</span>
              }
            </div>
            <div className="location-name gps gotham-medium-font">GPS Coordinates</div>
            <div className="location-coordinates nimbus-regular-font">({latitude}, {longitude})</div>
          </div>
          <div className="col-md" style={{ minHeight: '200px' }}>
            {!!latitude && !!longitude && <MapContainer
              latitude={latitude}
              longitude={longitude}
              containerElement={<div style={{ height: `185px`, width: '100%' }} />}
              mapElement={<div style={{ height: `100%` }} />}
            />}
          </div>
        </div>
      </section>
    </div>
  );
}

export default VenueLocation;